
import React from 'react';
import { cn } from '@/lib/utils';

type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';

interface LogoSpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const sizeMap: Record<SpinnerSize, string> = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24'
};

export const LogoSpinner: React.FC<LogoSpinnerProps> = ({ 
  size = 'md',
  className
}) => {
  return (
    <div className={cn(
      "animate-spin flex items-center justify-center",
      sizeMap[size],
      className
    )}>
      <img 
        src="/lovable-uploads/a5691e0a-4291-45f0-bd37-8d8834ef5118.png" 
        alt="Loading" 
        className="max-w-full max-h-full object-contain"
      />
    </div>
  );
};
